import { CalendarEventsList } from "./CalendarEventsList";

export default CalendarEventsList;
